import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Rooms from "@/components/Rooms";
import Attractions from "@/components/Attractions";
import Amenities from "@/components/Amenities";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, anchors: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain bg-cream font-sans text-stone-800 antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Rooms />
        <Attractions />
        <Amenities />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
